import { HttpInsuranceProductService } from './../../../../service/http-insurance-product.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FileUploadDto, ResultListDto } from '../../../../service/dto';
import { BankDepositUploadDto, PolicyScheduleUploadDto } from '../../../../service/dto-insurance';
import { EMPTY, finalize, Subscription, switchMap } from 'rxjs';
import { OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { HttpFileService } from '../../../../service/http-file.service';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { HttpEventType } from '@angular/common/http';

interface PolicySchedule {
	date: string;
	reference: string;
	amount: number;
	description: string;
}

@Component({
	selector: 'app-product-schedule-list',
	standalone: false,
	templateUrl: './product-schedule-list.component.html',
	styleUrl: './product-schedule-list.component.scss'
})
export class ProductScheduleListComponent implements OnInit, OnDestroy {
	uploadedFile?: FileUploadDto;
	uploadProgress?: number;
	productId!: number;

	data?: ResultListDto<PolicyScheduleUploadDto>;
	pageIndex = 1;
	pageSize = 30;
	subscription = new Subscription();

	loading = false;
	columnRef: TableColumn[] = [

		{ "title": "ID", "property": "id" },
		{ "title": "Uploaded At", "cellRef": "refUploadedAt" },
		{ "title": "Agent", "cellRef": "refAgent" },
		{ "title": "Process Started At", "cellRef": "refProcessStartedAt" },
		{ "title": "Process Completed At", "cellRef": "refProcessCompletedAt" },

		{ "title": "Record Count", "property": "countOfRecords" },
		{ "title": "Successful Records", "property": "countOfSuccessfulRecords" },
		{ "title": "Failed Records", "property": "countOfFailedRecords" },
		{ "title": "Invalid Records", "property": "countOfInvalidRecords" },

		{ "title": "Removed Policies", "property": "removedPolicies" },
		{ "title": "Added Policies", "property": "addedPolicies" },
		{ "title": "Updated Members", "property": "updatedPolicies" },
	];


	constructor(
		private route: ActivatedRoute,
		private fileService: HttpFileService,
		private httpService: HttpInsuranceProductService,
		private fb: FormBuilder,
		private router: Router,
		private modal: NzModalService) {
	}
	ngOnInit(): void {
		this.subscription.add(this.route.parent!.parent!.paramMap.subscribe(paramMap => {
			this.productId = +paramMap.get("productId")!;
			this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] });
		}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	customUpload = (item: NzUploadXHRArgs): any => {
		this.uploadProgress = 0;

		const subscription = this.fileService.uploadWithProgress(item.name ?? 'bank-payment-received', item.file as any)
			.pipe(
				finalize(() => this.uploadProgress = undefined),
				switchMap((event) => {
					if (event.type === HttpEventType.UploadProgress) {
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgress = percentage == 100 ? 99 : percentage;
					}
					if (event.type === HttpEventType.Response) {
						this.uploadProgress = 100;
						this.uploadedFile = event.body as FileUploadDto;
						return this.httpService.createAndValidateSchedule(this.productId, 0, (event.body as FileUploadDto).uuid);
					}
					return EMPTY;
				})
			)
			.subscribe({
				next: (result) => {
					this.router.navigate(['/schedule', result.id, 'view'], { relativeTo: this.route });
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}
	doFetchUploads(input: OnTableChange) {
		this.pageIndex = input.pageIndex;
		this.pageSize = input.pageSize;
		this.loading = true;

		this.httpService.getSchedules(this.productId, this.pageIndex, this.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.data = result;
			});
	}
	doView(input: PolicyScheduleUploadDto) {
		// this.router.navigate(['schedule', input.id, 'view'], { relativeTo: this.route.parent });
		this.router.navigate([input.id, 'view'], { relativeTo: this.route.parent });
	}
}
